export const width=454;export const height=304;export default{width:width,height:height};